// Events used by auth to trigger actions in the App with postMessage
export const appPostMessageEventType = {
    login: 'STB_AUTH_LOGIN',
    logout: 'STB_AUTH_LOGOUT',
    updateToken: 'STB_AUTH_UPDATE_TOKEN',
    stepUp: 'STB_AUTH_STEP_UP',
};
// Events used in event listeners sent by the App
export const appEventMessageType = {
    newToken: 'STB_AUTH_NEW_TOKEN',
    loggedOut: 'STB_AUTH_LOGGED_OUT',
    navigateTo: 'STB_AUTH_NAVIGATE_TO',
    authFailed: 'STB_AUTH_FAILED',
};
export const AL_2 = 'https://id.storebrand.no/authn/al2';
export const AL_3 = 'https://id.storebrand.no/authn/al3';
export const AL_4 = 'https://id.storebrand.no/authn/al4';
